module.exports = __webpack_public_path__ + "img/company-onboarding.dcc34c65.svg";